import { axios } from '../_helpers';
import cookie from 'react-cookies';

export const UserService = {
    login,
    logout,
    ltiGenerateToken,
    changePassword,
    forgotPassword
};

function login(username, password,remember_password) {
        return new Promise(function (resolve, reject) {
            axios.post('adminAuthenticate', { username: username, password: password }).then((res) => {
                    if (res.isSuccess) {
                        if (remember_password == true) {
                            cookie.save('username', username, { path: '/' });
                            cookie.save('password', password, { path: '/' });
                        }else{
                            cookie.remove('username', { path: '/' });
                            cookie.remove('password', { path: '/' });
                        }
                        localStorage.setItem('token', res.token);
                        localStorage.setItem('user',JSON.stringify(res.data));
                        resolve(res);
                    } else {
                        reject(res.message);
                    }
                }).catch(error => {
                    reject(error.message);
                });
        })
};

function ltiGenerateToken(user) {
    // let custom_person_name=user.custom_person_name;
    let custom_person_id=user.custom_person_id;
    return new Promise(function (resolve, reject) {
        // axios.post('ltiGenerateToken', {custom_person_name,custom_person_id }).then((res) => {
            axios.post('ltiGenerateToken', {custom_person_id }).then((res) => {
                if (res.isSuccess && res.token) {
                    localStorage.setItem('token', res.token);
                    localStorage.setItem('user', JSON.stringify(user));
                    resolve(res);
                } else {
                    reject(res.message);
                }
            }).catch(error => {
                reject(error.message);
            });
    })
};

function logout() {
    // remove user from local storage to log user out
    return new Promise(function (resolve, reject) {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        resolve(null);
    })
}

function changePassword(params) {
    return new Promise(function (resolve, reject) {
        axios.post('updateAdminPassword', params).then((response) => {
            resolve(response)
        }).catch(error => { 
            reject(error.message);
        });
    });
};

function forgotPassword(params) {
    return new Promise(function (resolve, reject) {
        axios.post('forgotPassword', params).then((response) => {
            resolve(response)
        }).catch(error => { 
            reject(error.message);
        });
    });
};




// WEBPACK FOOTER //
// ./src/_services/auth.service.js